export const RSVP_BASE_URL = process.env.REACT_APP_API_BASEURL;
export const RSVP_API_KEY = process.env.REACT_APP_API_KEY;